import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import FinanceV2Layout from "./FinanceV2Layout";
import { NoteState } from "../../context/notes/NoteState";
import FinanceV2Services from "../../UserServices/FinanceV2Services";
import "./FinanceV2.css";

const BUCKET_LABELS = {
  current: "Current (0–30 days)",
  days_31_60: "31–60 days",
  days_61_90: "61–90 days",
  days_91_120: "91–120 days",
  over_120: "Over 120 days",
  // legacy keys
  "1_30": "31–60 days",
  "31_60": "61–90 days",
  "61_90": "91–120 days",
  over_90: "Over 120 days",
};

export default function FinanceV2Receivables() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    FinanceV2Services.getAccountsReceivable({ branch_id })
      .then((res) => setData(res.data?.data))
      .catch(() => toast.error("Could not load A/R aging"))
      .finally(() => setLoading(false));
  }, [branch_id]);

  const buckets = data?.buckets || {};

  return (
    <FinanceV2Layout>
      <div className="container-fluid px-0 py-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-0">Accounts receivable</h4>
            <small className="text-muted">Pending payments on orders · as of {data?.as_of}</small>
          </div>
          <Link to="/finance-v2/dashboard" className="btn btn-sm btn-outline-secondary">
            Dashboard
          </Link>
        </div>

        {loading ? (
          <p>Loading…</p>
        ) : (
          <>
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <div className="fv2-card">
                  <div className="text-muted small">Total A/R (orders pending)</div>
                  <div className="fv2-metric">{data?.total_ar ?? 0}</div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="fv2-card">
                  <div className="text-muted small">GL account 1200 balance</div>
                  <div className="fv2-metric">{data?.gl_ar_balance ?? 0}</div>
                </div>
              </div>
              {Object.entries(buckets).map(([key, val]) => (
                <div className="col-md-4 col-lg-2" key={key}>
                  <div className="fv2-card">
                    <div className="text-muted small">{BUCKET_LABELS[key] || key}</div>
                    <div className="fw-semibold">{val}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="fv2-table-wrap">
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Order</th>
                    <th>Order date</th>
                    <th>Days</th>
                    <th className="text-end">Pending</th>
                    <th>Bucket</th>
                  </tr>
                </thead>
                <tbody>
                  {(data?.details || []).map((r, i) => (
                    <tr key={i}>
                      <td>{r.client_name}</td>
                      <td>#{r.order_id}</td>
                      <td>{r.order_date}</td>
                      <td>{r.days_outstanding}</td>
                      <td className="text-end">{r.amount_pending}</td>
                      <td>{BUCKET_LABELS[r.bucket] || r.bucket}</td>
                    </tr>
                  ))}
                  {!data?.details?.length && (
                    <tr>
                      <td colSpan={6} className="text-center text-muted">
                        No outstanding receivables
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </FinanceV2Layout>
  );
}
